import { useQuery, UseQueryResult } from 'react-query';
import { WorkoutHistoryDetail } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams } from 'utils/functions';

import { MovementHistoryKey } from './movementHistoryKey';

/**
 * One timeline's header: type, description, the gym's display unit, and the Estimated
 * 1RM reference lift with its percentage table. The entries are a separate paginated
 * read — see useMovementHistoryEntries.
 */
function useMovementHistory(
  { athleteId, movementId, scoreType }: MovementHistoryKey,
  { enabled = true }: { enabled?: boolean } = {},
): UseQueryResult<{ data: WorkoutHistoryDetail }> {
  return useQuery(
    ['workout-history', 'movement', athleteId, movementId, scoreType],
    () =>
      client.get(
        `workout-history/movement/?${encodeUrlParams({
          athlete: athleteId,
          movement: movementId as string,
          score_type: scoreType as string,
        })}`,
      ),
    { enabled: enabled && !!athleteId && !!movementId && !!scoreType },
  );
}

export default useMovementHistory;
